export default __webpack_public_path__ + "static/media/Rent-Normans-Keyboard.4ad3e703.jpg";